import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Strategic.css';

// import { IoCheckmark } from 'react-icons/io';

import { IoCheckmark } from "react-icons/io5";

const sectionVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2 }
  })
};

const Strategic = () => {
  return (
    <div className="strategic-container">
      <div className="container">

      <motion.header
        className="strategic-hero"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        >
        <h1>Strategic Partnerships</h1>
        <p>
          At GGOEX, strategic partnerships are the cornerstone of sustainable growth and innovation in Africa's dynamic energy landscape. Our collaborative approach enables us to leverage complementary strengths, share risks, and accelerate the development of transformative energy solutions across the Gulf of Guinea region. Through carefully selected alliances, we create value that extends beyond individual projects to drive industry-wide advancement and regional energy security.
        </p>
      </motion.header>

      {/* Technical Alliances */}
      <motion.section
        className="strategic-section"
        custom={0}
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        >
        <h2>Technical Alliances</h2>
        <div className="strategic-cards">
          {/* Zentech Inc. */}
          <div className="strategic-card">
            <h3>
              <img src="../../Images/Zentech-Logo-Blue_Black.avif" alt="Zentech Logo" style={{verticalAlign:'middle',marginRight:'8px', width: '200px'}} />
              Zentech Inc. 
              <span>- Offshore Engineering Excellence</span>
            </h3>
            <div className="partner-desc">
              <strong>Partnership Overview:</strong> GGOEX has established a strategic partnership with Zentech Inc., a global leader in offshore rig conversions with over 40 years of engineering expertise. This alliance provides GGOEX with access to cutting-edge Mobile Offshore Production Unit (MOPU) conversion technology essential for our flagship Gulf of Guinea Gas Project (GGGP).
            </div>
            <p style={{marginTop:'1rem'}}>
              <strong>Joint Value Creation:</strong> Our collaboration with Zentech represents a synergistic partnership where international expertise meets local market knowledge. Zentech's proven track record includes successful MOPU conversions for BW Energy's Hibiscus Alpha project in West Africa and New Fortress Energy's Gulf of Mexico operations.
            </p>
            <ul style={{marginTop:'1rem'}}>
              <li><IoCheckmark color="blue" className="s-icon"/> MOPU conversion expertise for 20-year offshore operations with ABS-compliant designs</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Global engineering network with 180 professionals across eight international offices</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Advanced FEED methodology that reduces project execution risks and optimizes development timelines</li>
            </ul>
          </div>
          {/* Schlumberger */}
          <div className="strategic-card">
            <h3>
              <img src="../../Images/Schlumberger-Logo.png" alt="Schlumberger Logo" style={{verticalAlign:'middle',marginRight:'8px'}} />
              Schlumberger <span>- Advanced Drilling Technologies</span>
            </h3>
            <div className="partner-desc">
              <strong>Strategic Technology Partnership:</strong> Our alliance with Schlumberger ensures access to advanced drilling technologies, particularly Managed Pressure Drilling (MPD) systems crucial for Nigeria's challenging Niger Delta formations. This partnership enables precise control of annular pressure profiles throughout wellbores, reducing operational risks by up to 40%.
            </div>
            <ul style={{marginTop:'1rem'}}>
              <li><IoCheckmark color="blue" className="s-icon"/> Real-time drilling optimization with AI-driven platforms for enhanced performance and safety</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Advanced MPD technology for shallow gas hazard mitigation in Niger Delta operations</li>
              <li><IoCheckmark color="blue" className="s-icon"/> AI-powered seismic interpretation systems that analyze 3D volumes 10 times faster than traditional methods</li>
            </ul>
          </div>
        </div>
      </motion.section>

      {/* Commercial Partners */}
      <motion.section
        className="strategic-section"
        custom={1}
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2>Commercial & Government Partners</h2>
        <div className="strategic-cards">
          {/* GGML */}
          <div className="strategic-card">
            <h3>
              <img src="../../Images/GGML_LOGO.jpeg" alt="GGML Logo" style={{verticalAlign:'middle',marginRight:'8px'}} />
              Gulf of Guinea Midstream Limited (GGML)
            </h3>
            <div className="partner-desc">
              <strong>Foundational Partnership:</strong> Gulf of Guinea Midstream Limited serves as GGOEX's primary strategic equity shareholder, originally incorporated as Gulf of Guinea Methanol Limited in May 2013. This partnership extends beyond financial participation to active operational collaboration through transformative infrastructure projects.
            </div>
            <ul style={{marginTop:'1rem'}}>
              <li><IoCheckmark color="blue" className="s-icon"/> Strategic shareholding position that strengthens GGOEX's capital structure for growth initiatives</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Leadership in developing the ANOH CNG Industrial Park with $100 million in project investments</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Combined experience in gas processing, distribution, and industrial park development</li>
            </ul>
          </div>
          {/* Pi-CNG */}
          <div className="strategic-card">
            <h3>
              <img src="../../Images/PI_CNG.png" alt="Pi-CNG Logo" style={{verticalAlign:'middle',marginRight:'8px'}} />
              Presidential CNG Initiative (Pi-CNG)
            </h3>
            <div className="partner-desc">
              <strong>National Energy Alignment:</strong> GGML's majority shareholding position in the ANOH CNG Park through strategic partnership with the Presidential Compressed Natural Gas Initiative positions GGOEX within Nigeria's national energy transition framework. The Federal Government has committed N122 billion through the Midstream and Downstream Gas Infrastructure Fund.
            </div>
            <ul style={{marginTop:'1rem'}}>
              <li><IoCheckmark color="blue" className="s-icon"/> Direct connection to Nigeria's CNG conversion strategy targeting one million vehicles by 2027</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Formal endorsement from Pi-CNG with Program Director Engr. Michael Oluwagbemi confirming alignment with national objectives</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Access to nationwide CNG infrastructure investments exceeding $200 million</li>
            </ul>
          </div>
          {/* AGPC */}
          <div className="strategic-card">
            <h3>
              <img src="../../Images/ANOH.jpeg" alt="AGPC Logo" style={{verticalAlign:'middle',marginRight:'8px'}} />
              ANOH Gas Processing Company (AGPC)
            </h3>
            <div className="partner-desc">
              <strong>Strategic Infrastructure Integration:</strong> The ANOH Gas Processing Company Limited serves as a critical commercial partner through its strategic proximity to GGML's industrial park operations. Located just 1 kilometer from the ANOH CNG Park, AGPC provides reliable gas supply with processing capacity of 300 million standard cubic feet per day.
            </div>
            <ul style={{marginTop:'1rem'}}>
              <li><IoCheckmark color="blue" className="s-icon"/> Long-term offtake arrangements initially set at 30 MMscfd with competitive pricing for over 20-year contracts</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Direct pipeline connectivity reducing transportation costs and enhancing supply chain efficiency</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Substantial processing capacity ensuring operational flexibility and supply security</li>
            </ul>
          </div>
          {/* NNPC Limited */}
          <div className="strategic-card">
            <h3>
              <img src="../../Images/NNPC_Limited_Logo.jpg" alt="NNPC Logo" style={{verticalAlign:'middle',marginRight:'8px',width:'100px'}} />
              NNPC Limited
            </h3>
            <div className="partner-desc">
              <strong>National Strategic Alignment:</strong> NNPC Limited participates as a strategic partner in GGOEX's flagship projects, particularly the conceptual Gulf of Guinea Gas Project (GGGP) targeting Nigeria's OML blocks. This partnership aligns with Nigeria's "Decade of Gas" initiative and NLNG's Train-7 expansion requirements.
            </div>
            <ul style={{marginTop:'1rem'}}>
              <li><IoCheckmark color="blue" className="s-icon"/> Technical guidance and regulatory support for project development</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Access to Nigeria's gas infrastructure networks including the Offshore Gas Gathering System</li>
              <li><IoCheckmark color="blue" className="s-icon"/> Direct integration with national gas monetization objectives and domestic gas delivery obligations</li>
            </ul>
          </div>
        </div>
      </motion.section>

      {/* Governance and Value Creation */}
      <motion.section
        className="strategic-section gov"
        custom={2}
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2>Partnership Governance & Value Creation</h2>
        <div className="strategic-features">
          <div  className="strategic-conclusion">
            <h4>Technology Transfer and Capacity Building</h4>
            <p>
              GGOEX's partnership framework prioritizes knowledge transfer and local capacity building through comprehensive training programs. Our commitment to training 500 Nigerian geoscientists in advanced reservoir modeling by 2027 demonstrates alignment with Nigeria's local content requirements.
            </p>
          </div>
          <div  className="strategic-conclusion">
            <h4>Risk Mitigation Through Strategic Alliances</h4>
            <p>
              Our diversified partnership portfolio provides comprehensive risk mitigation across technical, commercial, and regulatory dimensions. International technology partnerships ensure access to proven solutions while government relationships provide policy support and market access essential for long-term success.
            </p>
          </div>
        </div>
        <div className="strategic-conclusion">
          GGOEX's strategic partnership framework creates a comprehensive ecosystem that supports our three-pillar business strategy while ensuring access to cutting-edge technologies, reliable commercial relationships, and strong government support essential for success in West Africa's dynamic energy landscape.
        </div>
      </motion.section>
        </div>
    </div>
  );
};

export default Strategic;
